import { resolveIcon as i, resolveLink as n } from "../../../helpers/index.js";
const p = (e) => {
  const t = e.properties?.rows.items.map((o) => ({
    icon: i(o.content.properties?.ikon),
    header: o.content.properties?.header,
    content: o.content.properties?.contact?.items.map((r) => ({
      text: r.content.properties?.text,
      phoneNumber: r.content.properties?.phoneNumber ? n(r.content.properties?.phoneNumber) : void 0,
      link: r.content.properties?.link ? n(r.content.properties?.link) : void 0
    })) || []
  }));
  return { headers: e.properties?.columns, rows: t };
}, s = (e) => e.map((t) => ({
  description: t.content.properties?.leftText,
  amount: t.content.properties?.rightText
})), a = (e) => e.map((t) => ({
  description: t.content.properties?.header,
  text: t.content.properties?.teaser,
  link: t.content.properties?.link ? n(t.content.properties?.link) : void 0,
  amount: t.content.properties?.price
})), c = (e) => e.map((t) => ({
  column1: t.content.properties?.column1Value?.markup,
  column2: t.content.properties?.column2Value,
  column3: t.content.properties?.column3Value
})), u = (e) => ({
  variant: "contact",
  header: e.properties?.header || "",
  items: p(e)
}), m = (e) => ({
  variant: "calculation",
  header: e.properties?.header || "",
  items: s(e.properties?.rows?.items)
}), d = (e) => ({
  variant: "ticket",
  header: e.properties?.header || "",
  items: a(e.properties?.rows?.items)
}), h = (e) => ({
  variant: "3Columns",
  header: e.properties?.header || "",
  items: {
    headers: {
      header1: e.properties?.column1Header || "",
      header2: e.properties?.column2Header || "",
      header3: e.properties?.column3Header || ""
    },
    rows: c(e.properties?.rows?.items)
  }
});
export {
  m as calculationTableDeliveryApiParser,
  u as contactTableDeliveryApiParser,
  h as threeColumnTableDeliveryApiParser,
  d as ticketTableDeliveryApiParser
};
